import { Component, OnInit, AfterContentChecked, ChangeDetectorRef, SimpleChanges} from '@angular/core';
import { ssrsReportsService } from '../Services/ssrs-reports.service';
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { SsrsReportJson, SsrsInputFields, HtmlKeyValue, ReportInputFields } from "../Models/common.model";
import { paginate } from "../Models/common.pagination";
import * as Global from "../Models/constants";
import * as _ from "lodash";

@Component({
    selector: 'ssrs-reports',
    templateUrl: './ssrs-reports.component.html',
    providers: [ssrsReportsService]
})

export class SsrsReportComponent implements OnInit, AfterContentChecked{
    form: FormGroup;
    reportInputFields: ReportInputFields;
    ssrsInputFields: SsrsInputFields[] = [];
    inputFields: SsrsInputFields[] = [];
    ssrsReports = {} as SsrsReportJson;
    csvReportType: string = Global.csvReportType;
    pdfReportType: string = Global.pdfReportType;
    xmlReportType: string = Global.xmlReportType;
    excelReportType: string = Global.excelReportType;
    pager: any = {};
    page = 1;
    pageSize = 1; //No of records per page
    maxPages = 10;
    pageOfItems: Array<any>;
    startIndex: number;
    endIndex: number;
    style: string;
    downloadType: string;
    isLoading: boolean = false;
    reportName: string = Global.ssrsReportName;
    loadingMessage: string = Global.ssrsReportLoadingMessage;
    requiredFieldMessage: string = Global.ssrsRequiredFieldMessage;
    requiredIndicatorMessage: string = Global.ssrsRequiredFieldButtonMessage;
    hidePagination: boolean = false;
    dropdownSettings: {};
    
    private _reportHtml: HtmlKeyValue[];
    get reportHtml(): HtmlKeyValue[] {
        return this._reportHtml;
    }
    set reportHtml(value: HtmlKeyValue[]) {
        this._reportHtml = value;
        this.setPage(this.reportHtml);
    }

    ngOnInit() {
        Global.AddLogs("SSRS Reports onInit method called");
        this.form = new FormGroup({});
        this.dropdownSettings = {
            singleSelection: false,
            idField: 'Value',
            textField: 'Label',
            itemsShowLimit: 6,
            allowSearchFilter: false
        };
    }

    ngAfterContentChecked(): void {
         this.cdRef.detectChanges()
    }

    ngOnChanges(changes: SimpleChanges) {
        // reset page if items array has changed
        if (changes.items.currentValue !== changes.items.previousValue) {
            this.onChangePage(this.page);
        }
    }

    constructor(private dataService: ssrsReportsService, private cdRef: ChangeDetectorRef) {
        Global.AddLogs("SSRS Reports Constructor before service method getInputFields");
        this.dataService.getInputFields().subscribe((data: ReportInputFields) => {
            this.hidePagination = data.HidePagination;
            this.inputFields = data.SsrsInputFields;
            this.reportName = data.ReportName;
            this.setFormvalues(this.inputFields);
            Global.AddLogs("InputFields loaded from service:" + JSON.stringify(data));
        })
    }

    setFormvalues(inputFields: SsrsInputFields[]) {
        try {
            this.ssrsInputFields = inputFields;
            this.ssrsInputFields.forEach(formControl => {
                if (formControl.IsRequired) {
                    this.form.addControl(formControl.Name, new FormControl(null, Validators.required));
                } else {
                    this.form.addControl(formControl.Name, new FormControl(null));
                }
            });

            this.ssrsInputFields.forEach(control => {
                if (control.Type == Global.textBox) {
                    this.form.get(control.Name).patchValue(control.DefaultValue);
                    Global.AddLogs("SetFormValues textbox default values:" + control.DefaultValue);
                }
                if (control.Type == Global.select) {
                    if (control.Name.toLocaleUpperCase() == 'BASE' || control.Name.toLocaleUpperCase() == 'MAIN_BASE' || control.Name.toLocaleUpperCase() == 'SEAT') {
                        this.form.get(control.Name).patchValue(control.DefaultValue);
                        Global.AddLogs("SetFormValues BASE ,MAIN_BASE ,SEAT default values:" + control.DefaultValue);
                    } else {
                        if (control.DefaultValues != null) {
                            control.DefaultValue = control.DefaultValues[0];
                            this.form.get(control.Name).patchValue(control.DefaultValue);
                            Global.AddLogs("SetFormValues Select controls default values:" + control.DefaultValue);
                        }
                    }
                }

                if (control.Type == Global.checkboxList) {
                    var labelTexts = [];
                    var defaultValues = [];
                    var selectedItems = { Label: '', Value: '' };

                    if (control.DefaultValues != null && control.DefaultValues.length > 0) {
                        control.Selections.forEach(item => {
                            if (control.DefaultValues != null && control.DefaultValues != undefined) {
                                let exists = control.DefaultValues.find((val) => val === item.Value)
                                if (exists) {
                                    let controlDefaultValue = _.cloneDeep(selectedItems);
                                    controlDefaultValue.Label = item.Label;
                                    controlDefaultValue.Value = item.Value;
                                    defaultValues.push(controlDefaultValue);
                                }
                            }
                        })
                        control.CheckboxListDefaultValues = defaultValues;
                        Global.AddLogs("SetFormValues Checkbox controls default values:" + JSON.stringify(defaultValues));
                    }
                    else {
                        control.Selections.forEach(item => {
                            if (control.DefaultValue != null && control.DefaultValue != "" && control.DefaultValue != undefined) {
                                if (item.Value.indexOf(control.DefaultValue) !== -1) {
                                    labelTexts.push(item.Label);
                                }
                            }
                        })

                        let controlDefaultValue = _.cloneDeep(selectedItems);
                        labelTexts.forEach(item => {
                            controlDefaultValue.Label = item;
                            controlDefaultValue.Value = control.DefaultValue;
                            defaultValues.push(controlDefaultValue);
                        })
                        control.CheckboxListDefaultValues = defaultValues;
                        Global.AddLogs("SetFormValues Checkbox controls default values:" + JSON.stringify(defaultValues));
                    }
                }
            })
        }
        catch (error) {
            Global.AddLogs(error);
        }
    }

    getReportDetails() {
        try {
            var formData = this.form.value;
            this.isLoading = true;

            this.dataService.getInputFields().subscribe((data: ReportInputFields) => {
                this.hidePagination = data.HidePagination;
                this.inputFields = data.SsrsInputFields;
                Global.AddLogs("GetReportDetails getInputFields recieved from service :" + data);
            })
            for (let i = 0; i < this.inputFields.length; i++) {
                if (this.inputFields[i].Type == Global.checkboxList) {
                    let value = [];
                    formData[this.inputFields[i].Name].forEach(checkbox => { value.push(checkbox.Value) });
                    this.inputFields[i].Value = value;
                } else {
                    this.inputFields[i].Value = formData[this.inputFields[i].Name];
                }
            }
            this.ssrsReports.FileType = Global.htmlReportType;
            this.ssrsReports.Inputs = this.inputFields;

            this.dataService.getSsrsReport(this.ssrsReports).subscribe((data: HtmlKeyValue[]) => {
                this.downloadType = data[0].Value;
                this.style = data[1].Value;
                this.reportHtml = data;
                this.reportHtml.splice(0, 2);  //Remove first style element 
                this.isLoading = false;
                Global.AddLogs("GetReportDetails data recieved from service :" + JSON.stringify(data));
            })
        }
        catch (error) {
            Global.AddLogs("GetReportDetails Exception logged :"+error);
        }
    }

    downloadReport(type: string) {
        try {
            let file;
            this.ssrsReports.FileType = type;
            this.dataService.downloadSsrsReport(this.ssrsReports).subscribe((response) => {

                if (type == Global.pdfReportType)
                    file = new Blob([response], { type: 'application/' + type + '' });
                if (type == Global.csvReportType || type == Global.xmlReportType)
                    file = new Blob([response], { type: 'text/' + type + '' });
                if (type == Global.excelReportType)
                    file = new Blob([response], { type: 'application/octet-stream' });
                var fileURL = URL.createObjectURL(file);
                const link = document.createElement('a');
                link.href = fileURL;
                link.download = this.reportName+'.' + type;
                link.click();
                //open the file in new window

                //if (window.navigator.msSaveOrOpenBlob) {
                //    window.navigator.msSaveOrOpenBlob(file, fileURL.split(':')[1] + '.');
                //} else {
                //    window.open(fileURL);
                //}
                //window.open(fileURL);
            })
        }
        catch (error) {
            Global.AddLogs("downloadReport Exception logged :" + error);
        }
    }

    onCalenderchange(event: any, name) {
        let formControlName = name;
        let formControlValue;
        if (event.type == "change") {
            formControlValue = event.target["value"];
        }
        else if (event.type == "changeDate") {
            formControlValue = event.format(0, "mm/dd/yyyy");
        }
        
        this.form.controls[formControlName].setValue(formControlValue);
    }

    onChangePage(pageOfItems: any) {
        // update current page of items and set the number of items on page change
        this.pageOfItems = pageOfItems;
        this.setPage(this.reportHtml);
    }

    setPage(html: HtmlKeyValue[]) {
        this.pager = paginate(html.length, this.page, this.pageSize, this.maxPages);

        //set nnumber of items per pages.
        this.startIndex = this.pager.startIndex + 1;
        this.endIndex = this.pager.endIndex + 1;
    }

}

